module.exports = __webpack_public_path__ + "img/placeholder.d04fc654.png";